import Divider from "@mui/material/Divider";

export default function TodoHeader() {
  return(
    <>
      <h1 style={{marginTop: 10}}>مهامي</h1>
      <Divider style={{width: "80%", marginTop: "-2px"}}/>
    </>
  );
}